import type {AppRouterContext} from "./context";

import {createRouter} from "@tanstack/react-router";

// routeTree.gen.ts is auto-generated by @tanstack/router-plugin at build/dev time.
// Run `pnpm dev` once to generate it from the files in src/pages/.
import {routeTree} from "./routeTree.gen";

/**
 * Factory that creates the fully configured application router.
 *
 * Called once at the App.tsx module level — not inside a component.
 * The router instance is stable across renders.
 */
export function createAppRouter(context: AppRouterContext) {
  return createRouter({
    context,
    defaultPreload: "intent",
    defaultStaleTime: 30_000,
    routeTree,
    scrollRestoration: true,
  });
}

/**
 * Module augmentation — makes `useRouter()`, `useNavigate()`, `useSearch()`, etc.
 * fully type-safe against our specific router instance everywhere in the app.
 */
declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
